<template>
	<div class="page">
		<!-- <Tip :tip="tip" /> -->
		<TopTab :list='tabList' :tabIndex='tabIndex' @tabClick='tabClick' />
		<div class="screen_div">
			<!-- <el-select class="select" style="width: 178px;" v-model="value" clearable placeholder="xx商城">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
			</el-select> -->
			<el-input placeholder="商品名称/ID/条码" v-model="screen.good_name" style="width: 200px;margin-right: 10px;"/>
			<el-select class="select" style="width: 140px;" v-model="screen.supplier_id" filterable clearable placeholder="供货商家名称" @visible-change='selectSupplier'>
			    <el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in supplierArr" :key="item.supplier_id" :label="item.supplier_name" :value="item.supplier_id" />
			</el-select>
			<el-select class="select" v-model="screen.brand_id" filterable clearable placeholder="商品品牌" @visible-change='selectBrand'>
			    <el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in brandArr" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id" />
			</el-select>
			<el-select class="select" v-model="screen.state" placeholder="上下架状态">
			    <el-option :key="0" label="全部" :value="0" />
				<el-option :key="1" label="上架" :value="1" />
			    <el-option :key="2" label="下架" :value="2" />
			</el-select>
			<el-button @click="handleCurrentChange(1)">筛选</el-button>
		</div>
		<div class="classify_div">
			<Classify :list='ClassifyList' />
			<el-divider class="el-divider" direction="vertical" />
			<div class="from_div">
				<el-table ref="multipleTable" class="table_div" :row-key="rowKey"
					:data="tableData"
					:header-cell-style="tabStyle" :span-method="objectSpanMethod"
					@selection-change="handleSelectionChange">
					<el-table-column label="商品信息" width="250">
						<template slot-scope="scope">
							<div class="row" style="align-items: center;">
								<img class="logo_img" :src="scope.row.cover_img != '' ? scope.row.cover_img : img" />
								<div class="col" style="margin-left: 20px;">
									<span>ID：{{ scope.row.good_id }}</span>
									<span>名称：{{ scope.row.good_name }}</span>
									<span>供货：{{ scope.row.good_source_text }}</span>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column type="selection" :reserve-selection="true" width="50" />
					<el-table-column label="规格名称" prop="spec_data_str" />
					<el-table-column label="成本价格" prop="cost_price">
						<template slot-scope="scope">
							<el-input class="input" placeholder="0" v-model="scope.row.cost_price"
								@change="inputChange(scope.row,'cost_price')" />
						</template>
					</el-table-column>
					<el-table-column label="成本加价" prop="cost_incr">
						<template slot-scope="scope">
							<el-input class="input" placeholder="0" v-model="scope.row.cost_incr"
								@change="inputChange(scope.row,'cost_incr')" />%
						</template>
					</el-table-column>
					<el-table-column label="汇率%" prop="tax_rate">
						<template slot-scope="scope">
							<el-input class="input" placeholder="0" v-model="scope.row.tax_rate" />
						</template>
					</el-table-column>
					<el-table-column label="销售价" prop="sale_price">
						<template slot-scope="scope">
							<div class="col">
								<el-input class="input" placeholder="0" v-model="scope.row.sale_price"
									@change="inputChange(scope.row,'sale_price')" />
								<span>毛利率：{{grossMargin(scope.row.sale_price,scope.row.cost_price)}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="划线价" prop="crossed_price">
						<template slot-scope="scope">
							<div class="col">
								<el-input class="input" placeholder="0" v-model="scope.row.crossed_price"
									@change="inputChange(scope.row,'crossed_price')" />
								<span>毛利率：{{grossMargin(scope.row.crossed_price,scope.row.cost_price)}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="100" prop="state_text">
						<template slot-scope="scope">
							<span>{{scope.row.state_text}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!--弹出层-->
		<Popup :name="name" :show="show" @close='close' />
		<div class="foot_div">
			<div class="btn_div">
				<el-button @click="toggleSelection(1)">全选</el-button>
				<el-button type="danger" @click="toggleSelection(0)">清空选择</el-button>
				<el-button type="primary">
					<el-dropdown placement="top" @command="handleCommand">
						<span class="el-dropdown-link">功能<i class="el-icon-caret-right"></i></span>
						<el-dropdown-menu slot="dropdown" class="dropdown-menu">
							<el-dropdown-item v-for="(item,index) in dropdownList"
								:command="item.value">{{item.lable}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-button>
			</div>
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
		<!--批量调利润-->
		<el-dialog title="批量调利润" :visible.sync="dialogVisible" width="30%" top="30vh" center destroy-on-close :before-close="handleClose">
			<div class="col">
				<span style="margin-bottom: 20px;">批量将所勾选商品，成本不变，在当前利润率的情况下，针对价格字段调整利润率：</span>
				<div class="col" v-for="(item,index) in form">
					<el-form class="row" ref="form" :model="item">
						<el-form-item style="margin-right: 40px;">
							<el-checkbox-group v-model="item.checked" @change="groupChange(item.checked,index)">
								<el-checkbox :label="item.label_name" />
							</el-checkbox-group>
						</el-form-item>
						<el-form-item>
							<el-radio-group v-model="item.type" @input="groupInput(index)">
								<el-radio label="1">指定为</el-radio>
								<el-radio label="2">上调</el-radio>
								<el-radio label="3">下调</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item>
							<div class="row">
								<el-input class="input_" placeholder="0" v-model="item.value" />
								<span>%</span>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="subMit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import TopTab from "../../../components/TopTab/TopTab.vue"
	import Classify from "../../../components/Classify/Classify.vue"
	import Popup from "../../../components/Popup/Popup.vue"
	import {
		goodLists,
		goodsCateLists,
		goodChangeProfit,
		goodChangePrice,
        supplierLists
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			TopTab,
			Classify,
			Popup
		},
		data() {
			return {
				tip: '对商城中商品的价格进行综合定价管理，从利润率角度，以批量快速调整商品价格。',
				img: 'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png',
				tabList: ['平台自营商品', '供应链商品', '供应商商品', '礼卡'],
                tabMap: [1, 3, 4, 5],
				tabIndex: 0,
				ClassifyList: [], //分类列表
				ClassifyList: [], //分类列表
                supplierArr: [],
                brandArr: [],
				screen: {
					good_id: '', //商品id
					good_name: '', //商品名称
					brcode: '',
					cate_id: '',
					brand_id: '',
					state: '',
					good_source: '',
					tag_id: '',
					sort: '',
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
				},
				total: 10,
				tableData: [],
				options: [],
				value: [],
				name: '',
				show: false,
				position: 0,
				rowSpanArr: [],
				dropdownList: [{
						lable: '批量调利润',
						value: 1
					},
					{
						lable: '热门推荐',
						value: 2
					}
				],
				multipleSelection: [],
				dialogVisible: false,
				form: [{ //批量调利润
						field: 'sale_price', //销售价格字段
						checked: false, //是否勾选
						level_id: '',
						type: '', //1=指定，2=上调，3=下调
						value: '', //value值
						label_name : '销售价'
					},
					{ //批量调利润
						field: 'crossed_price', //划线价格字段
						checked: false, //是否勾选
						level_id: '',
						type: '', //1=指定，2=上调，3=下调
						value: '', //value值
						label_name : '划线价'
					},
					{ //批量调利润
						field: 'cost_incr', //成本加价字段
						checked: false, //是否勾选
						level_id: '',
						type: '1', //1=指定，2=上调，3=下调
						value: '', //value值
						label_name : '成本加价'
					}
				]
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
			this.getGoodsCateList();
			this.getGoodList();
		},
		methods: {
			rowKey(row) {
				//唯一字段名称
				return row.sku_id
			},

			//获取分类列表
			getGoodsCateList() {
				goodsCateLists({
					cate_type: '1'
				}).then(res => {
					if (res.code == 0) {
						this.ClassifyList = res.data;
					}
				}).catch(err => {})
			},

			//获取商品列表
			getGoodList() {
				goodLists({
					...this.screen
				}).then(res => {
					if (res.code == 0) {
						this.total = res.count;
						res.data.forEach(i => {
							i.skus.forEach(j => {
								j.good_id = i.good_id
								j.good_name = i.good_name
								j.good_source_text = i.good_source_text
								j.cover_img = i.cover_img
							})
							this.tableData.push(...i.skus)
						})
						this.getRowSpan(this.tableData);
					}
				}).catch(err => {})
			},

			//输入框修改价格
			inputChange(val,field) {
				var value = ''
				switch (field) {
					case 'cost_price':
						value = val.cost_price != '' ? val.cost_price : 0
						break;
					case 'cost_incr':
						value = val.cost_incr != '' ? val.cost_incr : 0
						break;
					case 'sale_price':
						value = val.sale_price != '' ? val.sale_price : 0
						break;
					case 'crossed_price':
						value = val.crossed_price != '' ? val.crossed_price : 0
						break;
				}
				goodChangePrice({
					sku_id: val.sku_id,
					field: field,
					level_id: '',
					value: value
				}).then(res => {
					if(res.code == 0){
						this.$message.success('价格修改成功！');
					}else{
						this.$message.error(res.msg);
					}
				})
			},

			//点击按钮切换页面
			handleCurrentChange(page) {
				this.tableData = [];
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getGoodList();
			},

			//功能操作
			handleCommand(command) {
				if (this.multipleSelection.length == 0) {
					this.$message({
						message: '请选中需要批量处理的商品！',
						type: 'warning'
					});
					return
				}
				switch (command) {
					case 1:
						//批量调利润
						this.dialogVisible = true;
						this.form.forEach(item => {
							item.checked = false
							item.type = ''
							item.value = ''
						})
						break;
					case 2:
						//热门推荐
						break;
				}
			},

			//顶部tab切换
			tabClick(index) {
				this.tableData	= [];
				this.tabIndex = index
			    this.screen.good_source = this.tabMap[index];
			    this.screen.page = 1;
			    this.getGoodList();
			},
			
			cateClick(cate_id) {
			    console.log('cateClick', cate_id)
			    this.screen.cate_id = cate_id;
			    this.screen.page = 1;
			    this.getGoodList();
			},
			
			async selectSupplier(query) {
			    if (!query) {
			        return false;
			    }
			    const res = await supplierLists()
			    if (res.code) {
			        return this.$message.error(res.msg)
			    }
			    this.supplierArr = res.data;
			},
			
			async selectBrand(query) {
			    if (!query) {
			        return false;
			    }
			    const res = await goodsCateLists({cate_type: 3, cate_pid: 0, limit: 100})
			    if (res.code) {
			        return this.$message.error(res.msg)
			    }
			    this.brandArr = res.data;
			},

			toggleSelection(rows) {
				if (rows == 0) {
					//清空选项
					this.$refs.multipleTable.clearSelection();
				} else if (rows == 1) {
					//全选
					this.$refs.multipleTable.toggleAllSelection();
				} else {
					//单选
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				}
			},

			handleSelectionChange(val) {
				this.multipleSelection = val.map(obj => obj.sku_id);
			},

			//计算毛利率
			grossMargin(sales, cost) {
				var grossMargin = (sales - cost) / sales * 100;
				return sales == 0 ? 'null' : grossMargin.toFixed(2); // 返回保留两位小数的结果
			},

			//批量调利润弹窗
			handleClose(done) {
				done();
			},

			groupChange(checked, index) {
				this.form[index].type = checked ? '1' : '';
			},

			groupInput(index) {
				this.form[index].checked = true;
			},

			//确认批量调利润
			subMit() {
				let arr = this.form.filter(item => item.checked);
				if (arr.length == 0) {
					this.$message.warning('请选择需要调整利润的价格');
				} else {
					var subType = 0;
					arr.forEach(item => {
						item.checked = '1';
						if (item.value == '') {
							subType = -1;
						}
					})
					if (subType == 0) {
						goodChangeProfit({
							sku_ids: this.multipleSelection,
							data: arr
						}).then(res => {
							if (res.code == 0) {
								this.tableData = [];
								this.$message.success('调整成功！');
								this.getGoodList();
								this.dialogVisible = false;
								arr = [];
							} else {
								this.$message.error(res.msg);
							}
						})
					} else {
						this.$message.warning('请输入需要调整的利润率');
					}
				}
			},

			open(name) {
				this.name = name;
				this.show = true
			},

			close() {
				this.show = false
			},

			// 获取合并的数组
			getRowSpan(data) {
				this.rowSpanArr = [];
				// 遍历数据
				for (let i = 0; i < data.length; i++) {
					if (i === 0) {
						this.rowSpanArr.push(1);
						this.position = 0
					} else {
						if (data[i].good_id === data[i - 1].good_id) {
							this.rowSpanArr[this.position] += 1;
							// 且将数组添加 0 
							this.rowSpanArr.push(0);
						} else {
							this.rowSpanArr.push(1);
							this.position = i;
						}
					}
				}
			},

			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				// 只合并区域位置
				if (columnIndex === 0) {
					const _row = this.rowSpanArr[rowIndex];
					const _col = _row > 0 ? 1 : 0;
					return {
						rowspan: _row,
						colspan: _col
					}
				}
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		padding: 20px 20px 0 20px;
		min-height: -webkit-fill-available;
	}

	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}
	
	.logo_img{
		width: 60px;
		height: 60px;
		border-radius: 100%;
		border: 1px solid #f5f5f5;
		background: #fff;
	}

	.select {
		width: 128px;
		margin-right: 13px;
	}

	.classify_div {
		display: flex;
		flex-direction: row;
		margin-top: 20px;
		height: 540px;
		max-height: 100%;
	}

	.from_div {
		width: calc(100% - 100px);
		overflow: scroll;
	}

	.table_div {
		width: 100%;
	}

	.table_div::before {
		height: 0;
	}

	.input {
		width: 80px;
	}

	/deep/.input .el-input__inner {
		width: 80px;
		height: 30px;
		margin-bottom: 10px;
	}

	/deep/.input_ .el-input__inner {
		width: 80px;
		height: 30px;
		margin: 0 10px 0 30px;
	}

	.foot_div {
		position: absolute;
		display: flex;
		justify-content: space-between;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	.el-divider--vertical {
		height: 540px;
	}

	.btn_div {
		display: flex;
		margin-top: 15px;
		height: 40px;
	}

	.pagination {
		display: flex;
		padding: 20px 30px 20px 30px
	}

	.el-dropdown-link {
		padding: 15px 5px;
		cursor: pointer;
		color: #fff;
	}

	.dropdown-menu {
		margin-bottom: 25px !important;
	}
</style>